import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import Platform from "@/config/platform";
import { cheackQuery, ToBack } from "@/uitls/native";
import { useI18n } from 'vue-i18n'
import config from '@/uitls/version.json';


export default /*#__PURE__*/_defineComponent({
  name: 'Aboat',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const router = useRouter();
const route = useRoute();
const SVIP_ICON = require(`@/assets/${process.env.VUE_APP_NAME}/aboutLogo.png`);

onMounted(() => {
  cheackQuery(route);
});
const version = process.env.VUE_APP_VERSION as string;
const appname = process.env.VUE_APP_TITLE as string;
const channelId = process.env.VUE_APP_CHANNEL as string;

const __returned__ = { t, router, route, SVIP_ICON, version, appname, channelId, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})